// extracted by mini-css-extract-plugin
export var deleteModal = "_k3-0";